"use strict";

module.exports = function isObject(x) {
	return typeof x === "object" && x !== null;
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/is-object/index.js
// module id = ../node_modules/is-object/index.js
// module chunks = 5